module.exports = __webpack_public_path__ + "img/used-car-line-up-state.5f54a34d.jpg";